// extracted by mini-css-extract-plugin
export var buttons = "_bo-0";
export var buttonsActive = "_bo-h";
export var cancelConfirm = "_bo-1";
export var closeButton = "_bo-2";
export var column = "_bo-3";
export var container = "_bo-4";
export var detailHeader = "_bo-6";
export var detailTitle = "_bo-7";
export var detailsContent = "_bo-5";
export var header = "_bo-8";
export var headerWithClose = "_bo-9";
export var icon = "_bo-a";
export var infoIcon = "_bo-c";
export var informationContainer = "_bo-b";
export var sideDrawer = "_bo-d";
export var sideDrawerOpen = "_bo-e";
export var stickyFooter = "_bo-f";
export var typeOption = "_bo-g";